import { useNavigate } from 'react-router-dom'

import clsx from 'clsx'
import { observer } from 'mobx-react-lite'

import { RoutingPaths } from 'app/routes/routes'

import { HeaderTabs } from 'widgets/header-tabs'
import { ActiveBooking } from 'widgets/kyrgyzstan/active-booking'
import { BestOffers } from 'widgets/kyrgyzstan/best-offers'
import { Collections } from 'widgets/kyrgyzstan/collections'
import { RestPlaces } from 'widgets/kyrgyzstan/rest-places'

import { CreateObjectEntry } from 'features/kyrgyzstan/create-object-entry'

import { kyrgyzstanSearchStore } from 'entities/kyrgyzstan'
import {
  KyrgyzstanOnboardingWrapper,
  SearchFormKyrgyzstan,
} from 'entities/kyrgyzstan/ui'

import { BottomNavigation } from 'shared/ui/bottom-navigation'

import s from './styles.module.scss'

const KyrgyzstanMainPage = observer(() => {
  const navigate = useNavigate()

  const handleSearch = () => {
    kyrgyzstanSearchStore.reset()
    kyrgyzstanSearchStore.resetFilters()
    navigate(RoutingPaths.kyrgyzstan.searchResult.path())
  }

  return (
    <KyrgyzstanOnboardingWrapper>
      <div className={s.container}>
        <HeaderTabs module="kyrgyzstan" />

        <div className={s.searchForm}>
          <SearchFormKyrgyzstan
            onSearch={handleSearch}
            action={<CreateObjectEntry />}
          />
        </div>

        <div className={clsx('container', s.lastOrder)}>
          <ActiveBooking />
        </div>

        <div className={s.restPlaces}>
          <RestPlaces />
        </div>

        <div className={s.collections}>
          <Collections />
        </div>

        <BestOffers
          limit={6}
          className={s.offers}
        />

        <BottomNavigation activeId="home" />
      </div>
    </KyrgyzstanOnboardingWrapper>
  )
})

export default KyrgyzstanMainPage
